import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Tooltip, Divider, Dropdown, Menu, Radio, Image } from 'antd';
import { apiHolder, apis, inWindow, conf, getIn18Text, getDingTalkSearchString, } from 'api';
import classnames from 'classnames';
import { handleKf, handleKfScriptLoad } from '@web-common/components/LingxiKfEntry';
import { navigate } from 'gatsby';
import { transAvatarSize } from '@web-common/utils/contact_util';
import AvatarTag from '@web-common/components/UI/Avatar/avatarTag';
import { OldVersionModal } from '@web-mail/components/OldVersionEntry/OldVersionModal';
import { useSharedAccountsUnread } from '@web-mail/hooks/useSharedAccountsUnread';
import ToolbarDownloadModal from '@web-common/components/ToolbarDownloadModal/toolbarDownloadModal';
import AvatarEditor from '@web-common/components/UI/AvatarEditor/avatarEditor';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
import Toast from '@web-common/components/UI/Message/SiriusMessage';
import { useNiceModal } from '@web-common/components/UI/NiceModal/NiceModal';
import { WelcomeModal } from '@web-common/components/UI/welcome_guide/welcome_guide';
import AiAssistant from '@web-common/components/AiAssistant';
import { actions as mailTabActions } from '@web-common/state/reducer/mailTabReducer';
import { navigateWithSearchQuery } from '@web-common/utils/utils';
import useRemoteDebugTools from '@web-common/hooks/useRemoteDebugTools';
import { actions as LoginActions, doSharedAccountAsync, doSwitchSharedAccountAsync, doSwitchAccountAsync, doListAccountsAsync, } from '@web-common/state/reducer/loginReducer';
import { getHelperCenterUrl } from '@web-common/utils/getHelperCenterUrl';
import { useAppDispatch, useAppSelector, useActions } from '@web-common/state/createStore';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import variables from '@web-common/styles/export.module.scss';
import { debounce, cloneDeep } from 'lodash';
import lodashGet from 'lodash/get';
import FeedbackModal from '@/components/Electron/FeedBack/feedbackModal';
import { ReactComponent as IconSetting } from '@/images/icons/account_setting_white.svg';
import { ReactComponent as IconComputer } from '@/images/icons/toolbar_computer.svg';
import { ReactComponent as IconSelfQuery } from '@/images/icons/self-query.svg';
import { ReactComponent as IconVip } from '@/images/icons/toolbar_vip.svg';
import { ReactComponent as IconTriangleDown } from '@/images/icons/toolbar_triangle_down.svg';
import { ReactComponent as AddIcon } from '@/images/icons/im/add-icon.svg';
import style from './webToolbar.module.scss';
import LangSwitchMenus from './langMenus';
import useFeatureVisibility from '@web-common/hooks/useFeatureVisibility';
const isEnLang = inWindow() && window.systemLang === 'en';
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const webmailApi = apiHolder.api.requireLogicalApi(apis.webmailApiImpl);
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const httpApi = apiHolder.api.getDataTransApi();
const mailConfigApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const storeApi = apiHolder.api.getDataStoreApi();
const systemApi = apiHolder.api.getSystemApi();
const loginApi = apiHolder.api.requireLogicalApi(apis.loginApiImpl);
const contactApi = apiHolder.api.requireLogicalApi('contactApi');
const eventApi = apiHolder.api.getEventApi();
const WebToolbar = () => {
    var _a, _b, _c, _d, _e, _f;
    const [showAvatarEditor, setShowAvatarEditor] = useState(false);
    const [curAvatar, setCurAvatar] = useState();
    const avatarInputRef = useRef(null);
    const [user, setUser] = useState();
    const [mailList, setMailList] = useState([]);
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const [backOldVisible, setBackOldVisible] = useState(false);
    const [isSharedAccount, setIsSharedAccount] = useState(false);
    const [loginEmail, setLoginEmail] = useState('');
    const [defaultLogo, setDefaultLogo] = useState(((_b = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.domainLogo) || 'https://cowork-storage-public-cdn.lx.netease.com/common/2024/03/12/6fbde457428d4e82b01e1aab31e1cb2e.png');
    const dispatch = useAppDispatch();
    const { sharedAccount, accountList, switchingAccount } = useAppSelector(state => state.loginReducer);
    const { unreadMap, fetchUnread } = useSharedAccountsUnread();
    const { localList } = accountList;
    const { setLoginModalData } = useActions(LoginActions);
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const [showEntry, setShowEntry] = useState(false);
    const [showActivity, setShowActivity] = useState(false);
    const isWebmail = inWindow() && conf('profile') ? conf('profile').toString().includes('webmail') : false;
    const [downloadVisible, setDownloadVisible] = useState(false);
    const [visibleAdmin, setVisibleAdmin] = useState(false);
    const isCorpMail = useAppSelector(state => state.loginReducer.loginInfo.isCorpMailMode);
    const vipAdmin = false;
    const isSirius = productVersionId === 'sirius';
    const qiyuLoading = useRef(false);
    const [event, setEvent] = useState(null);
    const contactId = useMemo(() => { var _a, _b; return ((_a = user === null || user === void 0 ? void 0 : user.contact) === null || _a === void 0 ? void 0 : _a.contact.id) || ((_b = user === null || user === void 0 ? void 0 : user.prop) === null || _b === void 0 ? void 0 : _b.contactId) || ''; }, [user]);
    const [isFreeMail, setIsFreeMail] = useState(false);
    const contactEmail = useMemo(() => (user === null || user === void 0 ? void 0 : user.id) || '', [user]);
    const paidGuideModal = useNiceModal('paidGuide');
    const SHOW_ACTIVITY = 'show_activity';
    const WELCOME_GUIDE = 'welcome_guide';
    const closeFeedback = () => {
        setShowFeedbackModal(false);
    };
    useEffect(() => {
        mailConfigApi.getIsFreeMailByCosId().then(res => {
            setIsFreeMail(res);
        });
    }, []);
    const getStore = (key) => {
        const result = storeApi.getSync(key);
        if (result.suc && result.data === 'true') {
            return true;
        }
        return false;
    };
    const handleBackEnd = async () => {
        var _a;
        const hl = inWindow() && window.systemLang === 'en' ? 'en_US' : 'zh_CN';
        const redirectUrl = mailConfigApi.getNewWebMailHost() + '/admin/login.do?hl=' + hl + '&uid=' + ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) + '&app=admin&all_secure=1';
        const url = await mailConfigApi.getWebSettingUrlInLocal('', { url: redirectUrl });
        if (url && url.length > 0) {
            systemApi.openNewWindow(url, false, undefined, undefined, true);
        }
        else {
            Toast.warn({
                content: getIn18Text('WUFADAKAIZHI'),
                duration: 3,
            });
        }
    };
    const checkIsSharedAccount = () => {
        accountApi.getIsSharedAccountAsync().then(res => {
            setIsSharedAccount(res);
        });
    };
    const showClientDownload = useFeatureVisibility('web_client_download_forbidden_domains');
    useEffect(() => {
        if (inWindow()) {
            setEvent(new CustomEvent(SHOW_ACTIVITY));
            const state = webmailApi.getState();
            if (state.show_old != null && +state.show_old === 1) {
                setShowEntry(true);
            }
            const { startTime, endTime } = webmailApi.getTimeRange().yun_bi_ji;
            const time = Date.now();
            if (!getStore(WELCOME_GUIDE) && time > startTime && time < endTime && isWebmail) {
                setShowActivity(true);
            }
            dispatch(doSharedAccountAsync());
            dispatch(doListAccountsAsync(false));
            checkIsSharedAccount();
        }
        const eid = eventApi.registerSysEventObserver('storeUserChangeEvent', {
            func: () => {
                var _a, _b;
                const logo = (_b = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.domainLogo;
                if (logo !== defaultLogo) {
                    setDefaultLogo(logo);
                }
                setUser(systemApi.getCurrentUser());
            },
        });
        return () => {
            eventApi.unregisterSysEventObserver('storeUserChangeEvent', eid);
        };
    }, []);
    useEffect(() => {
        if (!process.env.BUILD_ISEDM && productVersionId === 'free') {
            trackApi.track('web_show_freeup', { type: visibleAdmin ? '管理员' : '成员' });
        }
    }, [productVersionId]);
    const jumpToLogin = (retry) => {
        setTimeout(() => {
            const logoutPage = httpApi.getLogoutPage();
            console.warn('jump to logout page ', logoutPage);
            if (systemApi.getCurrentUser() === undefined) {
                window.location.assign(logoutPage);
            }
            else if (retry > 0) {
                jumpToLogin(retry - 1);
            }
            else {
                window.localStorage.clear();
                window.location.assign(logoutPage);
            }
        }, 700);
    };
    const logout = async () => {
        if (window.isInOtherApp) {
            await loginApi.logoutInOtherApp();
            return;
        }
        trackApi.track('pcMineCenter_click_logOut_mineCenterCard');
        await loginApi.doLogout(false, true);
        console.log('------ui will logout------');
        jumpToLogin(3);
    };
    const backToOldVersion = () => {
        setBackOldVisible(true);
    };
    const joinVip = () => {
        if (event != null) {
            window.dispatchEvent(event);
        }
    };
    const usageManual = () => {
        const helperUrl = 'https://lingxi.office.163.com/help/';
        systemApi.openNewWindow(helperUrl);
        trackApi.track('pcMineCenter_click_usageManual');
    };
    const helperCenter = () => {
        const helperUrl = getHelperCenterUrl({
            isEnLang,
            isEDM: Boolean(process.env.BUILD_ISEDM),
            productVersionId,
        });
        systemApi.openNewWindow(helperUrl);
        trackApi.track('pcMineCenter_click_helperCenter');
    };
    const feedback = async () => {
        if (systemApi.isElectron()) {
            systemApi.createWindow('feedback').then();
        }
        else {
            setShowFeedbackModal(true);
        }
    };
    const contactService = () => {
        handleKfScriptLoad(qiyuLoading).then(() => {
            handleKf({
                orgId: '',
                corpId: 0,
                corpName: '',
                domain: '',
            });
        });
    };
    const kefu = isSirius ? getIn18Text('ZHINENGKEFU') : vipAdmin ? getIn18Text('VIPKEFU') : getIn18Text('LIANXIKEFU');
    const { debugToolsVisible, remoteVisible, handleSnapshotClick, handleRemoteClick } = useRemoteDebugTools();
    const menu = (React.createElement(Menu, { className: style.toobarHelpMenu },
        !isEnLang ? (React.createElement(React.Fragment, null,
            productVersionId === 'free' && (React.createElement(Menu.Item, { key: "usageManual", onClick: ({ domEvent }) => {
                    domEvent.stopPropagation();
                    usageManual();
                } }, getIn18Text('usageManual'))),
            isFreeMail ? null : (React.createElement(Menu.Item, { key: "questionApply", onClick: ({ domEvent }) => {
                    domEvent.stopPropagation();
                    helperCenter();
                } }, getIn18Text('BANGZHUZHONGXIN'))))) : (React.createElement(React.Fragment, null, isFreeMail ? null : (React.createElement(Menu.Item, { key: "questionApply", onClick: ({ domEvent }) => {
                domEvent.stopPropagation();
                helperCenter();
            } }, getIn18Text('BANGZHUZHONGXIN'))))),
        React.createElement(Menu.Item, { key: "questionApply", onClick: ({ domEvent }) => {
                domEvent.stopPropagation();
                feedback();
            } }, getIn18Text('WENTIFANKUI')),
        productVersionId !== 'free' && (React.createElement(Menu.Item, { key: "contactServer", onClick: ({ domEvent }) => {
                domEvent.stopPropagation();
                contactService();
            } }, kefu)),
        React.createElement(Menu.Item, { key: "snapshot", onClick: ({ domEvent }) => {
                domEvent.stopPropagation();
                handleSnapshotClick();
            } }, debugToolsVisible ? getIn18Text('GUANBILUZ') : getIn18Text('LUZHIKUAIZ')),
        React.createElement(Menu.Item, { key: "remoteDebug", onClick: ({ domEvent }) => {
                domEvent.stopPropagation();
                handleRemoteClick();
            } }, remoteVisible ? getIn18Text('TINGZHIXIEZ') : getIn18Text('YUANCHENGXIEZ'))));
    useEffect(() => {
        setUser(systemApi.getCurrentUser());
    }, [lodashGet(systemApi.getCurrentUser(), 'avatar', '')]);
    useMsgRenderCallback('updateUserInfo', () => {
        setUser(systemApi.getCurrentUser());
    });
    useMsgRenderCallback('mailAliasAccountListChange', event => {
        const { newAlias } = event.eventData;
        if (newAlias) {
            setMailList(prev => [...prev, newAlias.id]);
        }
    });
    useEffect(() => {
        accountApi
            .doGetMailAliasAccountListV2({ noMain: true })
            .then(res => setMailList(res === null || res === void 0 ? void 0 : res.map(item => item === null || item === void 0 ? void 0 : item.id)))
            .catch(() => {
            setMailList([]);
        });
        accountApi.doGetAccountIsAdmin().then(res => setVisibleAdmin(res));
        setUser(systemApi.getCurrentUser());
    }, []);
    const handleMenuClick = (e) => {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        e === null || e === void 0 ? void 0 : e.preventDefault();
        if (switchingAccount) {
            return;
        }
        const id = e.target.value;
        const isSwitchingSharedAccount = sharedAccount.sharedAccounts.some(item => item.email === id) ||
            (sharedAccount.isSharedAccountLogin && !sharedAccount.isSharedAccountExpired && sharedAccount.email === id);
        if (isSwitchingSharedAccount) {
            dispatch(doSwitchSharedAccountAsync(id));
        }
        else {
            dispatch(doSwitchAccountAsync(id));
        }
    };
    const renderMainAccountTip = (_isSharedAccount, hasShareAccount = true) => {
        var _a, _b, _c, _d;
        const showNickName = _isSharedAccount ? sharedAccount.nickName : user === null || user === void 0 ? void 0 : user.nickName;
        const showEmail = _isSharedAccount ? sharedAccount.email : user === null || user === void 0 ? void 0 : user.id;
        const mainAccountTip = (React.createElement("div", { className: style.toolbarMainAccountWrap },
            React.createElement("div", { className: classnames(style.toolbarAccountPopoverAvatar, { [style.toolbarAccountSelected]: _isSharedAccount }), style: { marginBottom: 14 } },
                React.createElement(AvatarTag, { size: 40, showAccountSelected: !_isSharedAccount && hasShareAccount, user: {
                        name: showNickName,
                        avatar: _isSharedAccount ? '' : user === null || user === void 0 ? void 0 : user.avatar,
                        email: showEmail,
                        color: (_b = (_a = user === null || user === void 0 ? void 0 : user.contact) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.color,
                    } })),
            React.createElement("div", { className: style.toolbarAccountPopoverDesc },
                showNickName && React.createElement("div", { className: style.toolbarAccountPopoverNickname }, showNickName),
                showEmail && React.createElement("div", { className: style.toolbarAccountPopoverId }, showEmail),
                (user === null || user === void 0 ? void 0 : user.company) && React.createElement("div", { className: style.toolbarAccountPopoverCompanyname }, user === null || user === void 0 ? void 0 : user.company),
                !_isSharedAccount && (mailList === null || mailList === void 0 ? void 0 : mailList.length) ? React.createElement("div", { style: { color: `${variables.text5}`, marginTop: 12 } }, getIn18Text('BIEMINGYOUXIANG')) : '',
                !_isSharedAccount &&
                    (mailList === null || mailList === void 0 ? void 0 : mailList.map(alias => (React.createElement("div", { className: style.toolbarAccountPopoverId, key: alias }, alias)))),
                _isSharedAccount && ((_c = sharedAccount.alias) === null || _c === void 0 ? void 0 : _c.length) && (React.createElement("div", { style: { color: `${variables.text5}`, marginBottom: 4, marginTop: 12 } }, getIn18Text('BIEMINGYOUXIANG'))),
                _isSharedAccount &&
                    ((_d = sharedAccount.alias) === null || _d === void 0 ? void 0 : _d.map(alias => (React.createElement("div", { className: style.toolbarAccountPopoverId, key: alias }, alias)))))));
        return mainAccountTip;
    };
    const addAccount = () => {
        if (!systemApi.isElectron()) {
            dispatch(setLoginModalData({ visible: true }));
        }
    };
    const buildSharedAccountAliasTooltip = (aliasList) => {
        return (React.createElement("div", null,
            React.createElement("div", { style: { marginBottom: 4 } }, "\u516C\u5171\u8D26\u53F7\u522B\u540D\uFF1A"),
            aliasList.map((alias, idx) => (React.createElement("div", { key: idx }, alias)))));
    };
    const aliasPopover = (React.createElement("div", { className: style.toolbarAccountPopover, "data-test-id": "web-toolbar-avatar-popover" },
        sharedAccount.sharedAccounts.length || localList.length ? (React.createElement(Radio.Group, { value: user === null || user === void 0 ? void 0 : user.id, key: user === null || user === void 0 ? void 0 : user.id, style: {
                width: '100%',
                height: '100%',
                maxHeight: 388,
                overflowX: 'hidden',
                overflowY: 'auto',
            }, onChange: handleMenuClick },
            React.createElement(Radio, { value: sharedAccount.email, defaultChecked: !isSharedAccount }, renderMainAccountTip(isSharedAccount)),
            sharedAccount.sharedAccounts.map((it, idx) => {
                var _a, _b;
                return (React.createElement("div", { className: style.sharedAccountRadio, key: idx },
                    React.createElement(Radio, { value: it.email, defaultChecked: it.isCurrentAccount },
                        React.createElement(Tooltip, { overlayClassName: style.sharedAccountAliasTooltip, placement: "right", title: ((_a = it.alias) === null || _a === void 0 ? void 0 : _a.length) ? buildSharedAccountAliasTooltip(it.alias) : undefined },
                            React.createElement("div", { className: style.toolbarSharedAccount },
                                React.createElement("div", { className: style.avator }, switchingAccount === (it === null || it === void 0 ? void 0 : it.email) ? (React.createElement("div", { className: style.avatarLoadingWrap },
                                    React.createElement("div", { className: style.avatarLoading }))) : (React.createElement(AvatarTag, { size: 40, showAccountSelected: it.isCurrentAccount, user: {
                                        name: it === null || it === void 0 ? void 0 : it.nickName,
                                        email: it === null || it === void 0 ? void 0 : it.email,
                                        avatar: (it.isCurrentAccount ? (_b = systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.avatar : (it === null || it === void 0 ? void 0 : it.avatar) || '') || '',
                                    } }))),
                                React.createElement("div", { className: style.toolbarSharedAccountField },
                                    React.createElement("div", { className: style.toolbarSharedAccountFieldNickname },
                                        React.createElement("div", { className: style.toolbarSharedAccountFieldNicknameText },
                                            " ", it === null || it === void 0 ? void 0 :
                                            it.nickName),
                                        React.createElement("div", { className: style.sharedAccountTag }, getIn18Text('GONGGONGZHANGHAO')),
                                        unreadMap[it.email] > 0 && React.createElement("div", { className: style.sharedAccountUnreadBadge }, unreadMap[it.email] > 999 ? '999+' : unreadMap[it.email])),
                                    React.createElement("div", { className: style.toolbarSharedAccountFieldEmail }, it === null || it === void 0 ? void 0 : it.email)))))));
            }))) : (React.createElement("div", { className: style.toolbarAccountSingle }, renderMainAccountTip(false, false))),
        process.env.BUILD_ISEDM && (React.createElement("div", { className: style.addbtn, onClick: addAccount },
            React.createElement("div", { className: style.avator },
                React.createElement(AddIcon, null)),
            React.createElement("div", { className: style.right }, getIn18Text('TIANJIAQITAQIYEZHANG'))))));
    const checkAvatar = (e) => {
        var _a;
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        e === null || e === void 0 ? void 0 : e.preventDefault();
        if (isCorpMail) {
            return;
        }
        if (showAvatarEditor) {
            setShowAvatarEditor(false);
            return;
        }
        if (!(user === null || user === void 0 ? void 0 : user.avatar)) {
            (_a = avatarInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
        }
        else {
            const bigAvatar = transAvatarSize(user.avatar, 'big');
            setCurAvatar(bigAvatar);
            setShowAvatarEditor(true);
        }
    };
    const avatarInputChange = () => {
        var _a;
        const files = (_a = avatarInputRef === null || avatarInputRef === void 0 ? void 0 : avatarInputRef.current) === null || _a === void 0 ? void 0 : _a.files;
        if (files && files[0]) {
            const maxSize = 15 * 1024 * 1024;
            if (files[0].size > maxSize) {
                Toast.warn({ content: getIn18Text('TUPIANDAXIAOBU') });
                return;
            }
            setCurAvatar(files[0]);
            setShowAvatarEditor(true);
        }
    };
    const hasSharedAccount = sharedAccount && sharedAccount.sharedAccounts.length > 0;
    const [accountTooltipVisible, setAccountToolTipVisible] = useState(false);
    const debounceSetAvatar = debounce(async (sharedAccounts) => {
        let contactInfos = [];
        try {
            contactInfos = await contactApi.doGetContactByItem({ type: 'EMAIL', value: sharedAccounts.map(item => item.email) });
            if (!(contactInfos === null || contactInfos === void 0 ? void 0 : contactInfos.length))
                return;
        }
        catch (error) {
            console.error('debounceSetAvatar', error);
            return;
        }
        const newAccounts = sharedAccounts.map(oldItem => {
            var _a, _b;
            const item = cloneDeep(oldItem);
            const findOne = contactInfos.find(contact => { var _a; return ((_a = contact === null || contact === void 0 ? void 0 : contact.contact) === null || _a === void 0 ? void 0 : _a.accountName) === item.email; });
            if ((_a = findOne === null || findOne === void 0 ? void 0 : findOne.contact) === null || _a === void 0 ? void 0 : _a.avatar) {
                item.avatar = (_b = findOne === null || findOne === void 0 ? void 0 : findOne.contact) === null || _b === void 0 ? void 0 : _b.avatar;
            }
            return item;
        });
        dispatch(LoginActions.setSharedAccount(Object.assign(Object.assign({}, sharedAccount), { sharedAccounts: newAccounts })));
    }, 200);
    const handleAccountToolTipVisibleChanged = (visible) => {
        setAccountToolTipVisible(visible);
        if (visible) {
            const sharedAccounts = sharedAccount.sharedAccounts || [];
            (sharedAccounts === null || sharedAccounts === void 0 ? void 0 : sharedAccounts.length) && debounceSetAvatar(sharedAccounts);
            fetchUnread();
        }
    };
    useEffect(() => {
        if (process.env.BUILD_ISELECTRON)
            return;
        const currentUser = systemApi.getCurrentUser();
        if (isWebmail) {
            mailConfigApi
                .getOriginAccountAsync()
                .then(res => {
                if (res) {
                    setLoginEmail(res);
                }
                else {
                    setLoginEmail((currentUser === null || currentUser === void 0 ? void 0 : currentUser.loginAccount) || (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) || '');
                }
            })
                .catch(_ => {
                setLoginEmail((currentUser === null || currentUser === void 0 ? void 0 : currentUser.loginAccount) || (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) || '');
            });
        }
        else {
            setLoginEmail((currentUser === null || currentUser === void 0 ? void 0 : currentUser.loginAccount) || (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) || '');
        }
    }, []);
    return (React.createElement("div", { className: style.toolbarContainer, style: window.isInOtherApp ? { minWidth: '1012px' } : {} },
        React.createElement("div", { className: style.toolbarLeft },
            React.createElement("div", { className: style.toolbarLogoWrap, onClick: () => {
                    dispatch(mailTabActions.doChangeCurrentTab('-1/-1'));
                    navigate('/#mailbox');
                } }, defaultLogo ? (React.createElement(Image, { width: 140, style: { objectFit: 'contain' }, preview: false, src: defaultLogo })) : (React.createElement("span", { className: style.toolbarLogo, onClick: () => {
                    dispatch(mailTabActions.doChangeCurrentTab('-1'));
                    navigate('/#mailbox');
                } }))),
            React.createElement("div", { className: classnames(style.toolbarAccount, 'webToolbarAvatarTagWrapper'), "data-test-id": "web-toolbar-avatar" },
                React.createElement(Tooltip, { overlayClassName: style.toolbarAccountInner, className: style.toolbarAccountSender, placement: "bottomLeft", trigger: "hover", title: aliasPopover, onVisibleChange: handleAccountToolTipVisibleChanged },
                    React.createElement(AvatarTag, { size: 26, hasHover: !isCorpMail, user: {
                            name: user === null || user === void 0 ? void 0 : user.nickName,
                            avatar: user === null || user === void 0 ? void 0 : user.avatar,
                            email: user === null || user === void 0 ? void 0 : user.id,
                            color: (_d = (_c = user === null || user === void 0 ? void 0 : user.contact) === null || _c === void 0 ? void 0 : _c.contact) === null || _d === void 0 ? void 0 : _d.color,
                            logcAvatar: (user === null || user === void 0 ? void 0 : user.avatar) ? user === null || user === void 0 ? void 0 : user.avatar : undefined,
                        }, propEmail: user === null || user === void 0 ? void 0 : user.id, contactId: (_f = (_e = user === null || user === void 0 ? void 0 : user.contact) === null || _e === void 0 ? void 0 : _e.contact) === null || _f === void 0 ? void 0 : _f.id, onClick: checkAvatar }),
                    React.createElement("input", { ref: avatarInputRef, type: "file", accept: "image/gif, image/jpeg, image/jpg, image/png", className: style.avatarInput, onClick: e => {
                            e.target.value = '';
                        }, onChange: avatarInputChange }),
                    React.createElement("span", { className: style.toolbarAccountSenderShowName }, loginEmail),
                    hasSharedAccount && React.createElement("span", { style: { transform: `rotateZ(${accountTooltipVisible ? '0' : '180deg'})` }, className: style.toolbarAccountOpenIcon }))),
            React.createElement(Divider, { className: style.toolbarDivider, type: "vertical" }),
            React.createElement("div", { className: style.toolbarItem, onClick: () => {
                    trackApi.track('lingxiWeb_click_topBarButton', {
                        buttonName: '设置',
                    });
                    navigateWithSearchQuery('/#setting', { state: { currentTab: 'account' } });
                } },
                React.createElement(IconSetting, { className: style.toolbarItemIcon }),
                React.createElement("span", { className: style.toolbarItemLabel }, getIn18Text('SHEZHI'))),
            React.createElement(Divider, { className: style.toolbarDivider, type: "vertical" }),
            React.createElement("div", { className: style.toolbarItem, onClick: () => {
                    var _a;
                    trackApi.track('lingxiWeb_click_topBarButton', {
                        buttonName: '自助查询',
                    });
                    const currentSid = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.sessionId;
                    if (currentSid) {
                        const host = mailConfigApi.getNewWebMailHost();
                        const url = `${host}/static/rdmailquery/?sid=${currentSid}&hl=${isEnLang ? 'en_US' : 'zh_CN'}${getDingTalkSearchString(true)}`;
                        systemApi.openNewWindow(url, true);
                    }
                } },
                React.createElement(IconSelfQuery, { className: style.toolbarItemIcon }),
                React.createElement("span", { className: style.toolbarItemLabel }, getIn18Text('ZIZHUCHAXUN'))),
            React.createElement(Divider, { className: style.toolbarDivider, type: "vertical" }),
            showClientDownload ? (React.createElement("div", { className: style.toolbarItem, onClick: () => {
                    trackApi.track('lingxiWeb_click_topBarButton', {
                        buttonName: '客户端',
                    });
                    setDownloadVisible(true);
                } },
                React.createElement(IconComputer, { className: style.toolbarItemIcon }),
                React.createElement("span", { className: style.toolbarItemLabel }, getIn18Text('KEHUDUAN')))) : (React.createElement(React.Fragment, null)),
            visibleAdmin && !isCorpMail && (React.createElement(React.Fragment, null,
                ' ',
                React.createElement(Divider, { className: style.toolbarDivider, type: "vertical" }),
                React.createElement("div", { className: style.toolbarItem, onClick: () => {
                        trackApi.track('lingxiWeb_click_topBarButton', {
                            buttonName: '管理后台',
                        });
                        handleBackEnd();
                    } },
                    React.createElement(IconComputer, { className: style.toolbarItemIcon }),
                    React.createElement("span", { className: style.toolbarItemLabel }, getIn18Text('GUANLIHOUTAI'))))),
            !process.env.BUILD_ISEDM && productVersionId === 'free' && (React.createElement(React.Fragment, null,
                React.createElement(Divider, { className: style.toolbarDivider, type: "vertical" }),
                React.createElement("div", { className: style.toolbarItem, onClick: () => {
                        paidGuideModal.show({ errType: '5', origin: getIn18Text('DINGBUCAOZUOLAN') });
                    } },
                    React.createElement("span", { className: `${style.toolbarItemIconWrap} ${style.toolbarItemIcon}` }),
                    React.createElement("span", { className: `${style.toolbarItemLabelWarning} ${style.toolbarItemLabel}` }, getIn18Text('SHENGJIFUFEIBAN')))))),
        React.createElement("div", { className: style.toolbarRight },
            process.env.BUILD_ISWEB && React.createElement(AiAssistant, null),
            showActivity && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: style.toolbarItemRight, onClick: joinVip },
                    React.createElement(IconVip, { className: style.toolbarItemIcon }),
                    React.createElement("span", { className: style.toolbarItemLabel }, getIn18Text('LINGHUIYUAN'))),
                React.createElement(Divider, { className: style.toolbarDivider, type: "vertical" }))),
            React.createElement("div", { className: classnames(showActivity ? style.toolbarItem : style.toolbarItemRight) },
                React.createElement(Dropdown, { overlay: menu },
                    React.createElement("div", null,
                        React.createElement("span", { className: style.toolbarItemLabel }, getIn18Text('BANGZHUYUFANKUI')),
                        React.createElement(IconTriangleDown, { className: style.toolbarItemTriangle })))),
            React.createElement(Divider, { className: style.toolbarDivider, type: "vertical" }),
            React.createElement("div", { className: classnames(style.toolbarItem) },
                React.createElement(LangSwitchMenus, { labelClassName: style.toolbarItemLabel, iconClassName: style.toolbarItemTriangle, menuClassName: style.toobarHelpMenu })),
            React.createElement(Divider, { className: style.toolbarDivider, type: "vertical" }),
            React.createElement("div", { className: style.toolbarItem, onClick: logout, "data-test-id": "web-toolbar-logout" },
                React.createElement("span", { className: style.toolbarItemLabel }, getIn18Text('TUICHUDENGLU'))),
            showEntry && (React.createElement(React.Fragment, null,
                React.createElement(Divider, { className: style.toolbarDivider, type: "vertical" }),
                React.createElement("div", { className: style.toolbarItem, onClick: backToOldVersion },
                    React.createElement("span", { className: style.toolbarItemLabel }, getIn18Text('HUIDAOJIUBAN')))))),
        React.createElement(FeedbackModal, { visible: showFeedbackModal, cancel: () => closeFeedback() }),
        React.createElement(OldVersionModal, { defaultVisible: backOldVisible, closeModal: () => setBackOldVisible(false) }),
        React.createElement(ToolbarDownloadModal, { visible: downloadVisible, onClose: () => {
                setDownloadVisible(false);
            } }),
        isWebmail && React.createElement(WelcomeModal, null),
        showAvatarEditor && curAvatar && (React.createElement(AvatarEditor, { avatar: curAvatar, contactId: contactId, contactEmail: contactEmail, showResetEntry: true, onImageError: () => {
                const midAvatar = transAvatarSize((user === null || user === void 0 ? void 0 : user.avatar) || '', 'middle');
                setCurAvatar(midAvatar);
            }, hideAvatarEditor: () => setShowAvatarEditor(false) }))));
};
export default WebToolbar;
